import { Button } from '../../../ui';
import { copy } from '../copy';

function mmss(ms: number): string {
  const s = Math.ceil(ms / 1000);
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, '0')}`;
}

/** "Wait 10 minutes" (spec: delay before smoking). `until` and `now` are epoch ms. */
export function DelayTimer({
  until,
  now,
  onStart,
}: {
  until: number | null;
  now: number;
  onStart(): void;
}) {
  if (until === null) {
    return (
      <Button variant="secondary" block onClick={onStart}>
        {copy.wait10}
      </Button>
    );
  }
  if (until > now) {
    return (
      <p role="timer" className="text-center font-mono text-3xl tabular-nums text-fg">
        {copy.delayLeft(mmss(until - now))}
      </p>
    );
  }
  return <p className="text-center text-fg">{copy.delayDone}</p>;
}
